import { inject, Injectable } from '@angular/core';
import { PaymentIntent, StripeError } from '@stripe/stripe-js';

import { filter, from, map, Observable, of, switchMap, take } from 'rxjs';
import { CardService } from './card.service';
import { StripeService } from './stripe.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private cardService = inject(CardService);
  private toasts = inject(ToastService);
  private stripeService = inject(StripeService);

  public handlePayment(payment_intent: PaymentIntent): Observable<boolean | StripeError> {
    if (payment_intent.status !== 'requires_action') return of(true);
    return this.confirmCardPayment(payment_intent.client_secret).pipe(
      map(({ error }) => {
        if (!error) return true;
        console.error(error);
        this.toasts.add('Payment confirmation failed', 'error');
        return error;
      })
    );
  }

  private confirmCardPayment(secret: string) {
    return this.cardService.getCardData().pipe(
      filter(Boolean),
      take(1),
      switchMap(cardData => {
        return from(
          this.stripeService.confirmCardPayment(secret, {
            payment_method: cardData.paymentMethod,
          })
        );
      })
    );
  }
}
